/**
* @summary - Component that Provides forgot Password functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import { yupResolver } from "@hookform/resolvers/yup";
import { Alert, Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import axios from 'axios';
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
import * as yup from "yup";
import { ifacSecurityURL } from '../../utility/apiURLS';
import { encryptionKey } from "../../utility/secretKeys";
const ForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [emailSent, setEmailSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  // const schema = yup.object().shape({
  //   email: yup.string().email("Invalid email format").required("Email is required"),
  // });

  const schema = yup.object().shape({
    user: yup
      .string()
      .matches(/^\S*$/, 'Username should not contain spaces')
      .required('Username is required'),
  });

  const { register, handleSubmit, formState: { errors }, trigger } = useForm({
    resolver: yupResolver(schema)
  });
  const onSubmit = async (data) => {
    let response;
    try {
      trigger('user');
      const hostnameAndPort = `${window.location.hostname}:${window.location.port}`;
      response = await axios.post(`${ifacSecurityURL}/api/account/forgot-password`, { login: data.user, applicationSecurityKey: encryptionKey, url: hostnameAndPort,isemail:true });
      if (response.status === 200) {
        if (response?.data === 'Your account has been blocked') {
          setErrorMessage("Your Account has been Blocked already. Please contact IFAC-X Admin.");
        }
        else {
          setEmailSent(true);
          const timer = setTimeout(() => {
            navigate('/login');
          }, 5000); // 5000 milliseconds = 5 seconds
          return () => clearTimeout(timer); // cleanup the timer if the component unmounts
        }
      }
    } catch (error) {
      if (error?.response?.data?.status === 400 && error?.response?.data?.detail === "Email address not registered") {
        setErrorMessage("Email address not registered for this Username. Please contact IFAC-X Admin.");
      }
      else {
        trigger('user');
        setErrorMessage('Invalid Username. Please enter valid username.');
      }
    }
  };
  const handleClick = () => {
    navigate('/login');
  }

  return (
    <Paper sx={{ margin: '20px', paddingBottom: '10px', paddingRight: '10px', paddingLeft: '10px' }}>
      <Box mt={12} display="flex" flexDirection="column" alignItems="flex-start" >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Typography color={'text.primary'} component={'label'} variant="h5">
              Forgot Password
            </Typography>
          </Grid>
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', marginTop: '1rem' }}>
            <Grid container sx={{ display: "flex", justifyContent: "center" }}>
              <Grid item xs={3} md={1} style={{ marginTop: '20px', marginRight: '10px' }}>
                <Typography variant='h6' color={'text.primary'} component={'label'} >Username<Typography component={"span"} color={"error"}>
            *
          </Typography> </Typography>
              </Grid>
              <Grid item xs={4} md={4}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="user"
                  placeholder="Enter Your Username"
                  //label="Email Address"
                  name="user"
                  autoComplete="user"
                  autoFocus
                  {...register("user")}
                  error={!!errors.user}
                  helperText={errors.user ? errors.user.message : ''}
                  onFocus={() => setErrorMessage('')}
                />     </Grid></Grid>
            <Grid item xs={12} md={12}>
              <Typography sx={{ margin: 2 }} >
                Enter your Username and click "Submit". An user with the subject "Reset Password" will be sent to your registered Email ID. Visit the link sent in this mail where you can set your new password.
              </Typography>
            </Grid>
            {errorMessage && (
              <Alert severity="error" sx={{ mt: 3, fontSize: '12px', fontWeight: '400', color: '#D31A21', alignItems: 'center' }}>
                <strong>{errorMessage}</strong>
              </Alert>

            )}

            {emailSent ? (
              <Grid container spacing={2} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                <Alert severity="success" style={{ marginTop: '1rem' }}>
                  A reset link has been sent to your Email address.
                </Alert></Grid>
            ) : (
              <Grid container spacing={2} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", marginRight: '5px' }}>
                <Grid item xs={3} md={2} >
                  <Button type="submit" fullWidth variant="contained" color="primary" style={{ marginTop: '1rem' }}>
                    Submit
                  </Button>
                </Grid>
                <Grid item xs={3} md={2}>
                  <Button onClick={handleClick} fullWidth variant="outlined" color="primary" style={{ marginTop: '1rem' }}>
                    Back
                  </Button>

                </Grid>
              </Grid>
            )}

          </form>
        </Grid>
      </Box>
    </Paper>
  );
};

export default ForgotPassword;
